
import { AfterViewInit, Component, Injector, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { Router ,NavigationEnd} from '@angular/router';
import { Subscription } from 'rxjs';

//import { FacebookService, InitParams } from 'ngx-facebook';
import { DataService } from './data.service';
import { MetaService } from './meta-service.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy{

  dropDown:Boolean = false;
  sortDropDown:Boolean = false;
  showSideBar = false;
  searchText:string = '';
  private searchInputListener = (event: Event) => this.handleSearchInputEvent(event);
  private routerEventsSubscription?: Subscription;
  
  constructor(private metaService: MetaService,private dataService:DataService,private router: Router,private titleService: Title, private meta:Meta , private service:DataService, private zone: NgZone, private injector: Injector){

  //   this.router.events.subscribe((evt) => {
  //     if (!(evt instanceof NavigationEnd)) {
  //         return;
  //     }
  //     window.scrollTo(0, 0)
  // });

  }

  ngOnInit(){
    this.searchText = this.service.getSearch();
    this.service.currentSearch.subscribe(searchText =>{
      this.searchText = searchText;
    });
    this.routerEventsSubscription = this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.closeSideBar();
        this.hidePopUp();
        this.hideInitialRouteShell();
      }
    });

  }

  ngAfterViewInit(){
    document.addEventListener('input', this.searchInputListener);
    document.addEventListener('keyup', this.searchInputListener);
    this.startWebMcpWhenIdle();
  }

  private startWebMcpWhenIdle(): void {
    const start = async () => {
      const { ReferralWebMcpRegistrationService } = await import('./referral-webmcp-registration.service');
      this.injector.get(ReferralWebMcpRegistrationService).start();
    };

    const windowWithIdle = window as Window & { requestIdleCallback?: (callback: () => void, options?: { timeout: number }) => number };
    if (windowWithIdle.requestIdleCallback) {
      windowWithIdle.requestIdleCallback(() => void start(), { timeout: 5000 });
    } else {
      window.setTimeout(() => void start(), 3500);
    }
  }

  private hideInitialRouteShell(): void {
    const shell = document.querySelector<HTMLElement>('.initial-route-shell');
    if (!shell || shell.classList.contains('initial-route-ready')) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => shell.classList.add('initial-route-ready'));
    });
  }

  ngOnDestroy(){
    document.removeEventListener('input', this.searchInputListener);
    document.removeEventListener('keyup', this.searchInputListener);
    this.routerEventsSubscription?.unsubscribe();
  }

  showDropDown(){
    return this.dropDown;
  }

  toggleDropDown(){
    this.dropDown = !this.dropDown;
  }

  showSortDropDown(){
    return this.sortDropDown;
  }

  toggleSortDropDown(){
    this.sortDropDown = !this.sortDropDown;
  }

  hidePopUp(){
    this.dropDown = false;
    this.sortDropDown = false;
  }

  // initFacebookService(): void {
  //   const initParams: InitParams = { xfbml:true, version:'v3.2'};
  //   this.facebookService.init(initParams);
  // }

  toggleSideBar(){
    this.showSideBar = !this.showSideBar;
  }

  getSideBar():boolean{
    return this.showSideBar;
  }

  closeSideBar(){
    this.showSideBar = false;
  }

  sortData(sort:string){
    this.dropDown = false;
    this.sortDropDown = false;
    this.service.setSort(sort);
    if(this.router.url !="/all-referrals" && this.router.url !="/my" && this.router.url !="/sg" && this.router.url !="/e-wallet"&& this.router.url !="/cashback"&& this.router.url !="/others"&& this.router.url !="/investment"){
      this.router.navigate(["/all-referrals"]);
    }
  }

  sortDataCloseSide(sort:string){
    this.showSideBar = false;
    this.service.setSort(sort);
  }

  triggerSearch(searchText?:string){
    this.searchText = searchText !== undefined ? searchText : this.searchText;
    this.service.setSearch(this.searchText);
  }

  onSearchTextChange(searchText:string){
    this.searchText = searchText;
    this.service.setSearch(searchText);
  }

  clearSearch(){
    this.searchText = '';
    this.service.setSearch('');
  }

  showSearchBar(): boolean {
    const currentUrl = this.router.url.split("?")[0].split("#")[0];
    return ["/all-referrals", "/my", "/sg"].includes(currentUrl);
  }

  private handleSearchInputEvent(event: Event){
    const target = event.target as HTMLInputElement;
    if(!target || target.getAttribute('aria-label') !== 'Search referral apps'){
      return;
    }

    this.zone.run(() => this.triggerSearch(target.value));
  }

  goToFb(){
    window.open("https://www.facebook.com/MyReferralPromoCode", "_blank");
  }

  goToYt(){
    window.open("https://www.youtube.com/channel/UCmFZyQSU2n0Iu_koQFE1tqQ","_blank")
  }

  getTrustBank(){
    return(this.router.url.includes("trust-bank"));
  }

  


}

function HostBinding(arg0: string) {
  throw new Error('Function not implemented.');
}

